(function () {
  "use strict";

  angular.module("services").service("VirtualFairService", VirtualFairService);

  VirtualFairService.$inject = ["$http", "API_BASE", "$q"];

  function VirtualFairService($http, API_BASE, $q) {
    var service = this;

    service.getByFilterBoothTableBooked = getByFilterBoothTableBooked;
    service.getByFilterBoothTableBookedCSV = getByFilterBoothTableBookedCSV;
    service.storeSeminar = storeSeminar;
    service.updateSeminar = updateSeminar;
    service.deleteSeminar = deleteSeminar;
    service.getByFilterSeminar = getByFilterSeminar;
    service.getSeminarById = getSeminarById;
    service.getDeleteEventVisitors = getDeleteEventVisitors;
    service.deleteEventVisitors = deleteEventVisitors;
    service.getByFilterPreApproved = getByFilterPreApproved;
    service.getByFilterApproved = getByFilterApproved;
    service.getByFilterApprovedCSV = getByFilterApprovedCSV;
    service.getAlbums = getAlbums;
    service.getVideos = getVideos;
    service.getBrochures = getBrochures;
    service.getNationalities = getNationalities;
    service.getRepresentatives = getRepresentatives;
    service.getPhotos = getPhotos;
    service.getBooths = getBooths;
    service.updatePreApproved = updatePreApproved;
    service.getByFilterBoothSetup = getByFilterBoothSetup;
    service.getExhibitors = getExhibitors;
    service.all = all;
    service.getAll = getAll;
    service.getByTotalStudents = getByTotalStudents;
    service.findByUniversityConnect = findByUniversityConnect;
    service.generateScheduleUniversityConnect = generateScheduleUniversityConnect;
    service.getScheduleUniversityConnect = getScheduleUniversityConnect;
    service.findByPlatformTest = findByPlatformTest;
    service.storeTest = storeTest;
    service.updateTest = updateTest;
    service.storeTestIssue = storeTestIssue;
    service.updateTestStatus = updateTestStatus;
    service.exhibitorsSelect = exhibitorsSelect;
    service.representatives = representatives;
    service.representativesCSV = representativesCSV;
    service.sendCredentials = sendCredentials;
    service.sendCredential = sendCredential;
    service.whoPays = whoPays;
    service.howMuch = howMuch;
    service.programTypes = programTypes;
    service.countries = countries;
    service.getStudentsEnrolled = getStudentsEnrolled;
    service.getStudentsEnrolledCsv = getStudentsEnrolledCsv;
    service.sendInviteToStudentsEnrolled = sendInviteToStudentsEnrolled;
    service.getNetworkingEvent = getNetworkingEvent;
    service.getNetworkingEventCSV = getNetworkingEventCSV;
    service.getStudentsPhones = getStudentsPhones;
    service.getStudentsPhonesCsv = getStudentsPhonesCsv;
    service.getByFilterPlatformIntegration = getByFilterPlatformIntegration;
    service.platformSyncFairs = platformSyncFairs;
    service.platformSyncInit = platformSyncInit;
    service.platformSyncExec = platformSyncExec;
    service.platformSyncNew = platformSyncNew;
    service.getAllActive = getAllActive;
    service.getPreRegistrationsByFair = getPreRegistrationsByFair;
    service.getRegistrationsByUser = getRegistrationsByUser;
    service.saveRegister = saveRegister;
    service.getPartners = getPartners;
    service.getByFilterExhibitorsByExpo = getByFilterExhibitorsByExpo;
    service.getByFilterExhibitorsByExpoCSV = getByFilterExhibitorsByExpoCSV;
    service.getExpoTypes = getExpoTypes;
    service.getServiceRegions = getServiceRegions;
    service.getCostCenter = getCostCenter;
    service.getVirtualFairsBySettings = getVirtualFairsBySettings;
    service.getVirtualFairBySettings = getVirtualFairBySettings;
    service.saveVirtualFairSettings = saveVirtualFairSettings;
    service.sendEmailTest = sendEmailTest;
    service.deleteVirtualFair = deleteVirtualFair;
    service.virtualFairSettingsStatus = virtualFairSettingsStatus;
    service.getGeneralInformation = getGeneralInformation;
    service.getCyberSessionInformation = getCyberSessionInformation;
    service.getLeadsBooth = getLeadsBooth;
    service.getLeadsBoothCsv = getLeadsBoothCsv;
    service.leadsCSV = leadsCSV;
    service.getSchoolVisits = getSchoolVisits;
    service.getSchoolVisit = getSchoolVisit;
    service.storeSchoolVisit = storeSchoolVisit;
    service.deleteSchoolVisit = deleteSchoolVisit;
    service.getRequests = getRequests;
    service.getAllHighSchool = getAllHighSchool;
    service.getPostNetworkingEvents = getPostNetworkingEvents;
    service.getPostNetworkingEventsReport = getPostNetworkingEventsReport;
    service.getPostNetworkingEventsCSV = getPostNetworkingEventsCSV;
    service.generateStats = generateStats;
    service.hubLogin = hubLogin;
    service.setMaxRepresentatives = setMaxRepresentatives;
    service.eventSupport = eventSupport;
    service.getGeneralVisitors = getGeneralVisitors;
    service.getSemesters = getSemesters;
    service.eventContacts = eventContacts;
    service.eventContactsCsv = eventContactsCsv;
    service.updateEventData = updateEventData;
    service.getEventNumbers = getEventNumbers;
    service.getExhibitorLeadsCSV = getExhibitorLeadsCSV;
    service.getEventsByNow = getEventsByNow;
    service.getVirtualFairsBySemester = getVirtualFairsBySemester;
    service.getVirtualFairsWhatsAppReminder = getVirtualFairsWhatsAppReminder;
    service.sendWhatsAppReminder = sendWhatsAppReminder;
    service.getEventGroups = getEventGroups;
    service.getProfileTypes = getProfileTypes;
    service.getHubLoginUrl = getHubLoginUrl;
    service.getMicrositesByVirtualExpoId = getMicrositesByVirtualExpoId;
    service.getVirtualFairByEvent = getVirtualFairByEvent;
    service.getQuestions = getQuestions;
    service.getQuestionsCsv = getQuestionsCsv;
    service.getInterestAreas = getInterestAreas;
    service.getStudentsInterestAreas = getStudentsInterestAreas;
    service.getAllEvents = getAllEvents;
    service.getCyberSessions = getCyberSessions;
    service.getCyberSessionsByReport = getCyberSessionsByReport;
    service.getCyberSession = getCyberSession;
    service.getCyberSessionsWhitelistByReport = getCyberSessionsWhitelistByReport;
    service.getVirtualFairPavilions = getVirtualFairPavilions;
    service.getVirtualFairExposByPavilion = getVirtualFairExposByPavilion;
    service.getVirtualFairExposByPavilionAdded = getVirtualFairExposByPavilionAdded;
    service.saveExpos = saveExpos;
    service.getRatingComments = getRatingComments;
    service.getRatingCommentsDetails = getRatingCommentsDetails;
    service.getSummary = getSummary;
    service.getSurveys               = getSurveys;
    service.getSurveyQuestions       = getSurveyQuestions;
    service.getHosts = getHosts;
    service.getHostsById = getHostsById;
    service.storeHost = storeHost;
    service.updateHost = updateHost;
    service.getAddedHosts = getAddedHosts;
    service.removeHost = removeHost;
    service.getPrograms = getPrograms;
    service.getPrizes   = getPrizes;
    service.getReferrals = getReferrals;
    service.getWinners   = getWinners;
    service.generateWinners   = generateWinners;
    service.saveWinners   = saveWinners;
    service.getCounselors = getCounselors;
    service.getCounselorsCsv = getCounselorsCsv;


    /* HOSTS */ 
    function getHosts(query) {
      return $http.get(API_BASE + "/virtualfairs/hosts", {
        params: query,
      });
    }

    function getHostsById(id) {
      return $http.get(API_BASE + "/virtualfairs/hosts/" + id, {
        // params: query,
      });
    }

    function getAddedHosts(id) {
      return $http.get(API_BASE + "/virtualfairs/hosts/added/" + id, {
        // params: query,
      });
    }

    function storeHost(data) {
      let formData = new FormData();

      Object.keys(data).forEach(key => formData.append(key, data[key]));

      return $http
        .post(API_BASE + "/virtualfairs/hosts/store", formData, {
          transformRequest: angular.identity,
          headers: {'Content-Type': undefined}
        }).then(function (response) {
          return response.data;
        });
    }

    function updateHost(data, id) {
      let formData = new FormData();

      Object.keys(data).forEach(key => formData.append(key, data[key]));

      return $http
        .post(API_BASE + "/virtualfairs/hosts/update/" + id, formData, {
          transformRequest: angular.identity,
          headers: {'Content-Type': undefined}
        }).then(function (response) {
          return response.data;
        });
    }

    function removeHost(id) {
      return $http
        .delete(API_BASE + "/virtualfairs/hosts/" + id)
        .then(function (response) {
          return response.data;
        });
    }

    /* SEMINARS */
    function getByFilterSeminar(query) {
      return $http.get(API_BASE + "/virtualfairs/seminar", {
        params: query,
      });
    }

    function getSeminarById(id) {
      return $http.get(API_BASE + "/virtualfairs/seminar/" + id);
    }

    function storeSeminar(query) {
      return $http
        .post(API_BASE + "/virtualfairs/seminar/store", query)
        .then(function (response) {
          return response.data;
        });
    }

    function updateSeminar(data, id) {
      return $http
        .put(API_BASE + "/virtualfairs/seminar/" + id, data)
        .then(function (response) {
          return response.data;
        });
    }

    function deleteSeminar(id) {
      return $http
        .delete(API_BASE + "/virtualfairs/seminar/" + id)
        .then(function (response) {
          return response.data;
        });
    }


    /* DELETE EVENT VISITORS */
    function getDeleteEventVisitors() {
      return $http.get(API_BASE + "/virtualfairs/delete-event-visitors");
    }

    function deleteEventVisitors(id) {
      return $http.delete(API_BASE + "/virtualfairs/delete-event-visitors/" + id);
    }
    
    /* PRE-APPROVED */
    function getByFilterPreApproved(query) {
      return $http.get(API_BASE + "/virtualfairs/preapproved", {
        params: query,
      });
    }

    /* APPROVED */
    function getByFilterApproved(query) {
      return $http.get(API_BASE + "/virtualfairs/approved", { params: query });
    }

    function getByFilterApprovedCSV(query) {
      return $http.get(API_BASE + "/virtualfairs/approved/csv", { params: query });
    }

    function getAlbums(query) {
      return $http.get(API_BASE + "/virtualfairs/approved/albums", {
        params: query,
      });
    }

    function getVideos(query) {
      return $http.get(API_BASE + "/virtualfairs/approved/videos", {
        params: query,
      });
    }

    function getBrochures(query) {
      return $http.get(API_BASE + "/virtualfairs/approved/brochures", {
        params: query,
      });
    }

    function getNationalities(query) {
      return $http.get(API_BASE + "/virtualfairs/approved/nationalities", {
        params: query,
      });
    }

    function getRepresentatives(query) {
      return $http.get(API_BASE + "/virtualfairs/approved/representatives", {
        params: query,
      });
    }

    function getPhotos(query) {
      return $http.get(API_BASE + "/virtualfairs/approved/photos", {
        params: query,
      });
    }

    function getBooths(query) {
      return $http.get(API_BASE + "/virtualfairs/approved/booths", {
        params: query,
      });
    }

    function updatePreApproved(query) {
      return $http.get(API_BASE + "/virtualfairs/preapproved/update", {
        params: query,
      });
    }

    /* BOOTH-SETUP */
    function getByFilterBoothSetup(query) {
      return $http.get(API_BASE + "/virtualfairs/booth-setup", {
        params: query,
      });
    }

    /* BOOTH TABLE BOOKED */

    function getByFilterBoothTableBooked (query)
    {
        return $http.get(API_BASE + '/virtualfairs/boothtablebooked',{params:query});
    }

    function getByFilterBoothTableBookedCSV (query)
    {
        return $http.get(API_BASE + '/virtualfairs/boothtablebooked/csv',{params:query});
    }


    /* VIRTUAL FAIR EXHIBITORS */
    function getExhibitors(query) {
      return $http.get(API_BASE + "/virtualfairs/exhibitors", {
        params: query,
      });
    }

    function getVirtualFairsForSelect() {
      return $http.get(API_BASE + "/virtualfairs/list_select");
    }

    function all(query) {
      return $http.get(API_BASE + "/virtualfairs", { params: query });
    }

    function getAll(query) {
      return $http.get(API_BASE + "/virtualfairs/list", { params: query });
    }

    function getAllEvents(platformRental = false, query = {}) {
        if(platformRental) {
            query['platform-rental'] = 1;
        }
        return $http.get(API_BASE + '/platform-rental/events', {params: query});
    }

    function getByTotalStudents(query, platformRental = false) {
      return $http.get(API_BASE + "/virtualfairs/getStudentsTotal" + (platformRental ? '?platform-rental=1' : ''), {
        params: query,
      });
    }

    function findByUniversityConnect(query) {
      return $http.get(API_BASE + "/virtualfairs/findByUniversityConnect", {
        params: query,
      });
    }

    function generateScheduleUniversityConnect(virtual_fair_id) {
      return $http.get(
        API_BASE +
          "/universityconnect/" +
          virtual_fair_id +
          "/generateSchedules"
      );
    }

    function getScheduleUniversityConnect(virtual_fair_id, user_id, user_type) {
      return $http.get(
        API_BASE +
          "/universityconnect/" +
          virtual_fair_id +
          "/" +
          user_type +
          "/" +
          user_id +
          "/getSchedule"
      );
    }

    function findByPlatformTest(query) {
      return $http.get(API_BASE + "/virtualfairs/findByPlatformTest", {
        params: query,
      });
    }

    /* SCHEDULE TESTS */
    function storeTest(data) {
      return $http
        .post(API_BASE + "/virtualfairs/tests/store", data)
        .then(function (response) {
          return response.data;
        });
    }

    function updateTest(data) {
      return $http
        .post(API_BASE + "/virtualfairs/tests/update", data)
        .then(function (response) {
          return response.data;
        });
    }

    function storeTestIssue(data) {
      return $http
        .post(API_BASE + "/virtualfairs/tests/issue/store", data)
        .then(function (response) {
          return response.data;
        });
    }

    function updateTestStatus(data) {
      return $http
        .post(API_BASE + "/virtualfairs/tests/status", data)
        .then(function (response) {
          return response.data;
        });
    }

    function exhibitorsSelect(query) {
      return $http.get(API_BASE + "/virtualfairs/exhibitorsByExpo", {
        params: query,
      });
    }

    function representatives(query) {
      return $http.get(API_BASE + "/virtualfairs/exhibitors/representatives", {
        params: query,
      });
    }

    function representativesCSV(query) {
      return $http.get(
        API_BASE + "/virtualfairs/exhibitors/representatives/csv",
        {
          params: query,
        }
      );
    }

    function sendCredentials(query) {
      return $http.post(
        API_BASE + "/virtualfairs/exhibitors/representatives/sendcredentials",
        query
      );
    }

    function sendCredential(query) {
      return $http.get(
        API_BASE + "/virtualfairs/exhibitors/representatives/sendcredential",
        { params: query }
      );
    }

    function setMaxRepresentatives(id, query) {
      return $http.post(API_BASE + `/virtualfairs/exhibitors/representatives/max/${id}`, query);
    }

    function whoPays(query) {
      return $http.get(API_BASE + "/virtualfairs/whopays", { params: query });
    }

    function howMuch(query) {
      return $http.get(API_BASE + "/virtualfairs/howmuch", { params: query });
    }

    function programTypes(query) {
      return $http.get(API_BASE + "/virtualfairs/program-types", { params: query });
    }

    function countries(query) {
      return $http.get(API_BASE + "/virtualfairs/countries", { params: query });
    }

    function getStudentsEnrolled(query) {
      return $http.get(API_BASE + "/virtualfairs/studentsenrolled", {
        params: query,
      });
    }

    function getStudentsEnrolledCsv(query) {
      return $http.get(API_BASE + "/virtualfairs/studentsenrolled/csv", {
        params: query,
      });
    }

    function sendInviteToStudentsEnrolled(query) {
      return $http.post(API_BASE + "/virtualfairs/studentsenrolled/invite", query);
    }

    function getNetworkingEvent(query) {
      return $http.get(API_BASE + "/virtualfairs/networking-event", {
        params: query,
      });
    }

    function getNetworkingEventCSV(query) {
      return $http.get(API_BASE + "/virtualfairs/networking-event/csv", {
        params: query,
      });
    }

    function getStudentsPhones(query) {
      return $http.get(API_BASE + "/virtualfairs/students/phones", {
        params: query,
      });
    }

    function getStudentsPhonesCsv(query) {
      return $http.get(API_BASE + "/virtualfairs/students/phones/csv", {
        params: query,
      });
    }

    function getByFilterPlatformIntegration(type, query) {
      return $http.get(
        `${API_BASE}/virtual-fair/platform-integration/${type}`,
        { params: query }
      );
    }

    async function platformSyncFairs(query) {
      return $http.get(`${API_BASE}/platform-sync/fairs`,
        { params: query }
      );
    }

    async function platformSyncInit(fair_id, type, query) {
      return $http.get(
        `${API_BASE}/platform-sync/${fair_id}/${type}/init`,
        { params: query }
      );
    }

    async function platformSyncExec(virtual_fair_id, fair_id, type, id) {
      const canceller = $q.defer();
      let promise = $http.post(
        `${API_BASE}/platform-sync/${virtual_fair_id}/${fair_id}/${type}/${id}/exec`
      , { timeout: canceller.promise });
      promise.cancel = () => {
        canceller.resolve();
      }
      return promise;
    }

    async function platformSyncNew(virtual_fair_id, sync_type, include_synced, item_id = null) {
      return $http.get(
        `${API_BASE}/integration-api-new/${virtual_fair_id}`,
        { params: { sync_type, include_synced, item_id } }
      );
    }

    function getStudentsPhonesCsv(query) {
      return $http.get(API_BASE + "/virtualfairs/students/phones/csv", {
        params: query,
      });
    }

    function getAllActive(query) {
      return $http.get(API_BASE + "/virtualfairs/active-fairs/list", {
        params: query,
      });
    }

    function getPreRegistrationsByFair(query) {
      return $http.get(API_BASE + "/virtualfairs/pre-registration-fairs/list", {
        params: query,
      });
    }

    function getRegistrationsByUser(query) {
      return $http.get(API_BASE + "/virtualfairs/registration-fairs/list", {
        params: query,
      });
    }

    function saveRegister(query) {
      return $http.post(API_BASE + "/virtualfairs/save/register", query);
    }

    function getPartners(query) {
      return $http.get(API_BASE + "/virtualfairs/partners/list", {
        params: query,
      });
    }

    function getByFilterExhibitorsByExpo(query) {
      return $http.get(API_BASE + "/virtualfairs/exhibitors-by-expo", {
        params: query,
      });
    }


    function getExpoTypes(query) {
      return $http.get(API_BASE + "/virtualfairs/expo-types/list", {
        params: query,
      });
    }

    function getByFilterExhibitorsByExpoCSV(query) {
      return $http.get(API_BASE + "/virtualfairs/exhibitors-by-expo/csv", {
        params: query,
      });
    }

    function getServiceRegions(query) {
      return $http.get(API_BASE + "/virtualfairs/service-regions/list", {
        params: query,
      });
    }

    function getCostCenter(query) {
      return $http.get(API_BASE + "/virtualfairs/service-cost-center/list", {
        params: query,
      });
    }

    function getVirtualFairsBySettings(query) {
      return $http.get(API_BASE + "/virtualfairs/settings/list", { params: query });
    }

    function getVirtualFairBySettings(id) {
      return $http.get(API_BASE + "/virtualfairs/settings/" + id + "/edit");
    }

    function saveVirtualFairSettings(query) {
      let formData = new FormData();
      Object.keys(query).forEach(key => formData.append(key, query[key]));
      return $http.post(API_BASE + "/virtualfairs/settings", formData, {
        transformRequest: angular.identity,
        headers: {'Content-Type': undefined}
      });
    }

    function sendEmailTest(data) {
      return $http.post(API_BASE + "/virtualfairs/settings/email-test", data);
    }


    function deleteVirtualFair(id) {
      return $http.post(API_BASE + "/virtualfairs/settings/" + id + '/delete');
    }

    function virtualFairSettingsStatus(id) {
      return $http.post(API_BASE + "/virtualfairs/settings/" + id + '/status');
    }

    function getGeneralInformation(query) {
      return $http.get(API_BASE + "/virtualfairs/general-information", {
        params: query,
      });
    }

    
    function getCyberSessionInformation(query) {
      return $http.get(API_BASE + "/virtualfairs/cyber-sessions-information", {
        params: query,
      });
    }

    function getLeadsBooth(query) {
      return $http.get(API_BASE + "/virtualfairs/leads-booth", {
        params: query,
      });
    }

    function getLeadsBoothCsv(query) {
      return $http.get(API_BASE + "/virtualfairs/leads-booth/csv", {
        params: query,
      });
    }

    function leadsCSV(id, query) {
      return $http.get(API_BASE + `/virtualfairs/leads/${id}/csv`, {params: query});
    }

    function getSchoolVisits(query) {
      return $http.get(API_BASE + "/virtualfairs/school-visit", {
        params: query,
      });
    }

    function getSchoolVisit(id) {
      return $http.get(API_BASE + "/virtualfairs/school-visit/" + id);
    }

    function storeSchoolVisit(data) {
      return $http.post(API_BASE + "/virtualfairs/school-visit", data);
    }

    function deleteSchoolVisit(id) {
      return $http.delete(API_BASE + "/virtualfairs/school-visit/" + id);
    }

    function getRequests() {
      return $http.get;
    }

    function getAllHighSchool(query) {
      return $http.get(API_BASE + "/virtualfairs/high-school/all", {
        params: query,
      });
    }

    function getPostNetworkingEvents(query) {
      return $http.get(API_BASE + "/virtualfairs/networking-events/post", {
        params: query,
      });
    }

    function getPostNetworkingEventsReport(data) {
      return $http.post(API_BASE + "/virtualfairs/networking-events/post", data);
    }

    function getPostNetworkingEventsCSV(query) {
      return $http.get(API_BASE + "/virtualfairs/networking-events/post/csv", {
        params: query,
      });
    }

    function generateStats(data) {
      return $http.post(API_BASE + "/virtualfairs/generate-stats", data);
    }

    function hubLogin(data) {
      return $http.post(API_BASE + "/virtualfairs/hub-login", data);
    }

    function eventSupport(data) {
      return $http.get(API_BASE + "/virtualfairs/event-support", {params: data});
    }

    function getGeneralVisitors(data) {
      return $http.get(API_BASE + "/virtualfairs/general-visitors", {params: data});
    }

    function getSemesters(data) {
      return $http.get(API_BASE + "/virtualfairs/semesters", {params: data});
    }

    function eventContacts(data) {
      return $http.get(API_BASE + "/virtualfairs/event-contacts", {params: data});
    }

    function eventContactsCsv(data) {
      return $http.get(API_BASE + "/virtualfairs/event-contacts/csv", {params: data});
    }

    function updateEventData(data) {
      return $http.post(API_BASE + "/virtualfairs/event-data/update", data)
        .then(function (response) {
          return response.data;
        });
    }

    function getEventNumbers(query) {
      return $http.get(API_BASE + "/virtualfairs/getEventNumbers", {
        params: query,
      });
    }

    function getExhibitorLeadsCSV(query) {
      return $http.get(API_BASE + "/virtualfairs/exhibitor-leads/csv", {
        params: query,
      });
    }
    function getEventsByNow(query) {
      return $http.get(API_BASE + "/virtualfairs/letter-type", {});
    }

    function getVirtualFairsBySemester(query) {
      return $http.get(API_BASE + "/virtualfairs/by-semester", {
        params: query,
      });
    }

    function getVirtualFairsWhatsAppReminder(query) {
      return $http.get(API_BASE + "/virtualfairs/opened", {
        params: query,
      });
    }

    function getEventGroups(query) {
      return $http.get(API_BASE + "/virtualfairs/event-groups", {
        params: query,
      });
    }


    function sendWhatsAppReminder(data) {
      return $http.post(API_BASE + "/virtualfairs/whatsapp-reminder", data);
    }

    function getProfileTypes(query) {
      return $http.get(API_BASE + "/virtualfairs/profile-types", {
        params: query,
      });
    }

    function getHubLoginUrl(email, token, virtual_fair_id) {
      let query = {};
      query['email'] = email;
      query['token'] = token;
      query['virtual_fair_id'] = virtual_fair_id;
      return $http.get(API_BASE + "/virtualfairs/get-hub-login-url", {
        params: query,
      });
    }

    function getMicrositesByVirtualExpoId(query) {
      return $http.get(API_BASE + "/virtualfairs/get-microsites", {
        params: query,
      });
    }

    function getVirtualFairByEvent(query) {
      return $http.get(API_BASE + "/virtualfairs/expo-types-fpp-event/list", {
        params: query,
      });
    }

    function getQuestions(query) {
      return $http.get(API_BASE + "/virtualfairs/help-report/"+query, {});
    }

    function getQuestionsCsv(query) {
      return $http.get(API_BASE + "/virtualfairs/help-report-csv/"+query, {});
    }

    function getInterestAreas() {
      return $http.get(API_BASE + "/virtualfairs/interest-areas");
    }

    function getStudentsInterestAreas(query) {
      return $http.get(API_BASE + "/virtualfairs/students-interest-areas/", {params: query});
    }

    function getCyberSessions(query) {
      return $http.get(API_BASE + "/virtualfairs/cyber-sessions/", {params: query});
    }

    function getCyberSessionsByReport(query) {
      return $http.get(API_BASE + "/virtualfairs/cyber-sessions/report/", {params: query});
    }

    function getCyberSession(id) {
      return $http.get(API_BASE + "/virtualfairs/cyber-session/" + id);
    }

    function getCyberSessionsWhitelistByReport(query) {
      return $http.get(API_BASE + "/virtualfairs/cyber-sessions/whitelist/report/", {params: query});
    }

    function getRatingComments(query) {
      return $http.get(API_BASE + "/virtualfairs/rating-comments/", {params: query});
    }

    function getRatingCommentsDetails(id) {
      return $http.get(API_BASE + "/virtualfairs/rating-comments/details/" + id);
    }

    function getVirtualFairPavilions(query) {
      return $http.get(API_BASE + "/virtualfairs/pavilions/list", { params: query });
    }
    
    function getVirtualFairExposByPavilion(id) {
      return $http.get(API_BASE + `/virtualfairs/pavilion/${id}/get-fair-expos`);
    }

    function getVirtualFairExposByPavilionAdded(id) {
      return $http.get(API_BASE + `/virtualfairs/pavilion/${id}/get-fair-expos-added`);
    }

    async function saveExpos(payload){
      return $http.post(API_BASE + `/virtualfairs/pavilion/save-expos`, payload )
    }

    function getSummary(query) {
      return $http.get(API_BASE + "/virtualfairs/summary", {params: query});
    }

    /* ROADSHOW SURVEYS */
    function getSurveys(query) {
      return $http.get(API_BASE + '/survey/virtual/list', {params: query});
    }

    function getSurveyQuestions(query) {
        return $http.get(API_BASE + '/survey/virtual/question/list', {params: query});
    }
    function getPrograms(id) {
      return $http.get(API_BASE + "/virtualfairs/programs/list",{params: query});
    }

    function getPrizes(query){
      return $http.get(API_BASE + "/virtualfairs/prizes/list",{params: query});
    }

    function getReferrals(query){
      return $http.get(API_BASE + "/virtualfairs/referrals/list",{params: query});
    }

    function getWinners(query){
      return $http.get(API_BASE + "/virtualfairs/prizes/winners/list",{params: query});
    }
    function generateWinners(query){
      return $http.get(API_BASE + "/virtualfairs/prizes/winners/generate",{params: query});
    }
    function saveWinners(payload){
      return $http.post(API_BASE + "/virtualfairs/prizes/winners", payload);
    }

    /* COUNSELORS */
    function getCounselors(query) {
      return $http.get(API_BASE + "/virtualfairs/counselors", { params: query });
    }

    function getCounselorsCsv(query) {
      return $http.get(API_BASE + "/virtualfairs/counselors/csv", { params: query });
    }
  }
})();
